import type { ArticleCoverColor as ArticleCoverColor } from '@haaretz/s-types';

export const coverColors: ArticleCoverColor[] = [
  'athena',
  'black',
  'herra',
  'neutral',
  'venus',
  'yellow',
];

export default function isArticleCoverColor(
  coverColor?: string | null
): coverColor is ArticleCoverColor {
  return coverColors.includes(coverColor as ArticleCoverColor);
}
